import { Navigate } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'
import { logout } from '../services/actions/authActions'

const PrivateRoute = ({ children }) => {
	const token = localStorage.getItem('token')

	if (!token) return <Navigate to='/login' />

	try {
		const decoded = jwtDecode(token)
		if (decoded.exp < Date.now() / 1000) {
			console.warn('🔒 Token expired')
			logout()
			return <Navigate to='/login' />
		}
	} catch {
		logout()
		return <Navigate to='/login' />
	}

	return children
}

export default PrivateRoute
